import { create } from "zustand";
import { persist } from "zustand/middleware";
import type { MembershipRole, Project, User } from "@/api/types";

interface ProjectState {
  projects: Project[];
  currentProject: Project | null;
  setProjects: (projects: Project[]) => void;
  setCurrentProject: (project: Project | null) => void;
  setCurrentBySlug: (slug: string) => Project | null;
}

export const useProjectStore = create<ProjectState>()(
  persist(
    (set, get) => ({
      projects: [],
      currentProject: null,
      setProjects: (projects) => {
        const current = get().currentProject;
        const stillExists = current
          ? projects.find((p) => p.slug === current.slug) ?? null
          : null;
        set({
          projects,
          currentProject: stillExists ?? current ?? null,
        });
      },
      setCurrentProject: (project) => set({ currentProject: project }),
      setCurrentBySlug: (slug) => {
        const project = get().projects.find((p) => p.slug === slug) ?? null;
        if (project) set({ currentProject: project });
        return project;
      },
    }),
    {
      name: "prism.project",
      partialize: (state) => ({
        currentProject: state.currentProject,
      }),
    },
  ),
);

export function roleForProject(
  user: User | null,
  project: Project | null,
): MembershipRole | null {
  if (!user || !project) return null;
  const m = user.memberships.find((mb) => mb.project_id === project.id);
  return m?.role ?? null;
}
